import React from "react";
import useAppContext, { ACCOUNT_TYPES } from "state/AppContext";
import AdminNotificationsPage from "pages/AdminView/AdminNotificationsPage/AdminNotificationsPage";
import ClientNotificationsPage from "pages/ClientView/ClientNotificationsPage/ClientNotificationsPage";
import RecruiterNotificationsPage from "pages/RecruitersView/RecruiterNotificationsPage/RecruiterNotificationsPage";
import ErrorPage from "pages/ErrorPage/ErrorPage";

export default function NotificationsSwitch() {
  const appContext = useAppContext();
  const { account } = appContext;
  const { accountType } = account;

  if (accountType.type === ACCOUNT_TYPES.ADMIN.type) {
    return <AdminNotificationsPage />;
  } else if (accountType.type === ACCOUNT_TYPES.RECRUITER.type) {
    return <RecruiterNotificationsPage />;
  } else if (accountType.type === ACCOUNT_TYPES.EMPLOYER_PRIVATE.type) {
    return <ClientNotificationsPage />;
  } else {
    return <ErrorPage />;
  }
}
